import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

import Popper from 'popper.js';
window.Popper = Popper;

export default jQuery;
